import ConfirmDialog from '@core/components/confirm-dialog/ConfirmDialog.vue'
import { VoucherService } from '@/api/voucher-service.js';

export default {
    props: {
        voucherDetailId: {
            type: Number,
            default: 0,
        },
        isOpen: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        'confirm-dialog': ConfirmDialog
    },
    data() {
        return {
            voucherDetail: null,
            listWeeklyCode: [
                {
                  text: this.$t('ar_voucher_monday'),
                  value: 'MON',
                },
                {
                  text: this.$t('ar_voucher_tuesday'),
                  value: 'TUE',
                },
                {
                  text: this.$t('ar_voucher_wednesday'),
                  value: 'WED',
                },
                {
                  text: this.$t('ar_voucher_thursday'),
                  value: 'THU',
                },
                {
                  text: this.$t('ar_voucher_friday'),
                  value: 'FRI',
                },
                {
                  text: this.$t('ar_voucher_saturday'),
                  value: 'SAT',
                },
                {
                  text: this.$t('ar_voucher_sunday'),
                  value: 'SUN',
                },
              ],
            fieldsTableService: [
                {
                  key: 'VoucherServiceGroupName',
                  label: 'Tên nhóm dịch vụ',
                  sortable: true,
                },
                {
                    key: 'DiscountType',
                    label: 'Loại giảm giá',
                    sortable: true,
                },
                {
                    key: 'Amount',
                    label: 'Tổng giảm giá',
                    sortable: true,
                }
              ],
              isShowTableService: false,
              listVoucherStatus: [
                {label: 'Có hiệu lực', code: 'VALID'},
                {label: 'Đã sử dụng', code: 'USED'},
                {label: 'Tạm ngưng', code: 'PAUSE'},
            ],
            listUsesVoucher: [
                { label: this.$t('ar_voucher_paper_voucher'), code: 0 },
                { label: this.$t('ar_voucher_electron_voucher'), code: 1 },
            ],
            valueUsesVoucher: 0,
        }
    }, 
    watch: {
        isOpen(value) {
            this.getDetailVoucher(this.voucherDetailId);
            this.$emit('update:isOpen', value);
        }
    },
    methods: {
        hideModal() {
            this.isShowTableService = false
            this.$bvModal.hide('modal-voucher-detail')
        },
        async getDetailVoucher(VoucherId) {
            const body = {
                Voucher: {
                    Id: VoucherId
                }
            }
            await VoucherService.getDetailVoucher_VC_RV02(body).then(res => {
                res.Data.Voucher.VoucherStatus = {
                    label: this.listVoucherStatus.find(x => x.code === res.Data.Voucher.VoucherStatus).label,
                    code: res.Data.Voucher.VoucherStatus
                }
                this.voucherDetail = res.Data.Voucher;
                this.valueUsesVoucher = this.listUsesVoucher[this.voucherDetail.MediaTypeId].label
            })
        },
        async updateVoucherDetail() {
            const body = {
                Voucher : {
                    Id:this.voucherDetail.Id,
                    OpenDate: this.voucherDetail.OpenDate,
                    ExpirationDate: this.voucherDetail.ExpirationDate,
                    WeeklyCode:this.voucherDetail.WeeklyCode,
                    SpecialDayId:this.voucherDetail.SpecialDayId,
                    Note:this.voucherDetail.Note,
                    VoucherStatus: this.voucherDetail.VoucherStatus.code
                }
            }
            await VoucherService.updateDetailVocher_VC_UV01(body).then(res => {
                this.showResToast(res)
                if(res.Status === "200") {
                    this.$emit('event', { type: 'after-delete_voucher'})
                    this.isShowTableService = false
                }
            })
        },
        async DeleteVoucher() {
            const body = {
                Voucher: {
                    Id: this.voucherDetail.Id
                }
            }
            await VoucherService.deteleDetailVoucher_VC_DV01(body).then(res => {
                this.showResToast(res)
                if( res.Status === "200") {
                    this.hideModal()
                    this.$emit('event', { type: 'after-update_voucher'})
                }
            })
        },
        async validDetailVoucher() {
            this.hideModal();
            this.$emit('PAUSED', this.voucherDetailId);
        }, 
        async invalidDetailVoucher() {
            this.hideModal();
            this.$emit('VALID', this.voucherDetailId);
        },
    },
}